import {
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarTrigger,
} from "@/components/ui/menubar.tsx";
import { useVisibleT } from "@/lib/cms/cms-new-i18n";
import { ChevronDownIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export interface SaveSheetButtonProps {
  onSave: (status?: "published" | "draft" | "bin") => void;
  /** Disables the "Save and publish" action; draft save stays available. */
  publishDisabled?: boolean;
  /** Optional extra classes for the trigger button. */
  className?: string;
}

/**
 * Save dropdown with "Save as draft" / "Save and publish" actions. Shared by
 * the sticky topbar (FormHeader) and the sheet header (FormHeadingMetadata)
 * so both render the exact same control.
 *
 * Libellé raccourci « Enregistrer » (ex-« Enregistrer la fiche ») — clé
 * `bo.form.save` à renseigner par CD.
 */
export function SaveSheetButton({
  onSave,
  publishDisabled = false,
  className,
}: SaveSheetButtonProps) {
  const { t } = useTranslation();
  const vt = useVisibleT();
  return (
    <Menubar className="border-none p-0 h-auto bg-transparent">
      <MenubarMenu>
        <MenubarTrigger
          className={
            "px-3 py-2 rounded-lg justify-center items-center gap-2 flex bg-primary text-white whitespace-nowrap min-w-fit" +
            (className ? ` ${className}` : "")
          }
          style={{ maxWidth: "100%", width: "auto" }}
        >
          <p className="text-sm font-semibold font-['Raleway'] truncate">
            {vt("bo.form.save", "Enregistrer")}
          </p>
          <ChevronDownIcon className="w-5 h-5" />
        </MenubarTrigger>
        <MenubarContent>
          <MenubarItem onClick={() => onSave("draft")}>
            {t("saveAsDraft")}
          </MenubarItem>
          <MenubarItem
            disabled={publishDisabled}
            onClick={() => onSave("published")}
          >
            {t("saveAndPublish")}
          </MenubarItem>
        </MenubarContent>
      </MenubarMenu>
    </Menubar>
  );
}

export default SaveSheetButton;
